import { NumberWithUnitsFormatter } from '@ddt-web/data-service';

/**
 * AnnuityHistogramChartTooltip
 */
export class AnnuityHistogramChartTooltip {
	public static getFormatter(customData?: any, displayCurrency: string = '$'): Function {
		const formatter = new NumberWithUnitsFormatter('0', '-', true);
		return function (): string {
			return `<div style="width:180px">
			<b>${customData.age}</b> ${this.point.category}
			<div>${this.point.series.name} <b>${displayCurrency + formatter.format(Number(this.point.y))}</b></div></div>`;
		};
	}
}
